import { call, takeLatest, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import ReportService from 'shared/services/ReportService';
import {
  TDateRange,
  TAction,
  TReportTimeframeResponse,
  TReportMomentaryResponse
} from 'shared/types';

import {
  getTimeframeReportsData,
  setTimeframeReportsData,
  getMomentaryReportsData,
  setMomentaryReportsData,
  getTimeframeReportsFail,
  getMomentaryReportsFail
} from './reports.redux';

function* getTimeframeReport({ payload }: TAction<TDateRange>) {
  try {
    const result: AxiosResponse<[TReportTimeframeResponse]> = yield call(
      ReportService.getReportsByTimeframeV2,
      payload
    );

    yield put(setTimeframeReportsData(result));
  } catch (error) {
    console.log('error', error);
    yield put(getTimeframeReportsFail());
  }
}

function* getMomentaryReport({ payload }: TAction<TDateRange>) {
  try {
    const result: AxiosResponse<[TReportMomentaryResponse]> = yield call(
      ReportService.getReportsByMomentary,
      payload
    );

    yield put(setMomentaryReportsData(result));
  } catch (error) {
    console.log('error', error);
    yield put(getMomentaryReportsFail());
  }
}

function* Reports() {
  yield takeLatest(getTimeframeReportsData.type, getTimeframeReport);
  yield takeLatest(getMomentaryReportsData.type, getMomentaryReport);
}

export default Reports;
